<template>
    <div :class="contentClass">
        <button @click.stop.prevent="doIt()" @click="handleClick" :aria-label="btn.ariaLabel" class="btn" :class="[customClass, 'btn-' + btn.type, { 'btn-no-label': btn.label == false }, { 'btn-loading': isLoading }]">
            <slot name="icon"></slot>
            <span> {{ btn.label ? btn.label : '' }}</span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        contentClass: { type: [String, Array], default: 'content-button' },
        bType: { type: String, default: 'normal' },
        bLabel: { type: [String, Boolean], default: '' },
        bCallback: { type: Function, default: function () {} },
        bCallbackProps: {
            type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
            default: undefined
        },
        customClass: { type: [String, Array, Object, Function], default: '' },
        isLoading: { type: Boolean, default: false },
        bTypeOfBtn: { type: String, default: 'button' }
    },
    data() {
        return {
            types: {
                cancel: { label: 'button.cancel', callback: function () {} },
                confirm: { label: 'popup.access.text_save', callback: function () {} }
            }
        }
    },
    computed: {
        btn() {
            var def = this.types[this.bType]
            var result = {
                type: this.bType ? this.bType : 'normal',
                label: this.bLabel === false ? false : this.bLabel != '' ? this.$t(this.bLabel) : this.$t(def.label),
                callback: this.bCallback ? this.bCallback : def.callback,
                props: this.bCallbackProps ? this.bCallbackProps : undefined,
                ariaLabel: def && def.ariaLabel ? this.$t(def.ariaLabel) : ''
            }
            return result
        }
    },
    methods: {
        doIt() {
            var self = this
            if (this.bType == 'save' && this.$store.getters['multilanguage/getTranslationLang']) {
                this.$nextTick(() => {
                    self.$store.dispatch('multilanguage/saveTranslations')
                })
            }

            if (!this.isLoading) {
                this.btn.callback(this.btn.props)
            }
        },
        handleClick() {
            this.$emit('on-button-click')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.content-title-des {
    width: auto;
    height: 20px !important;
    margin-left: 0;
    .btn {
        @include background($color: $color-neutral-200, $size: 15px, $position: 11px center);
        @include box-shadow($h: 0px, $v: 0px, $b: 4px, $s: 0px, $c: rgba($color-neutral-600, 0.05));
        padding: 8px 9px 8px 35px;
        margin: 0 0 0 0;
        font-size: 14px;
        height: 20px !important;
        width: fit-content;
        font-weight: 700;
        color: $color-white;
        border-radius: 4px;
        line-height: initial;

        span {
            font-weight: 700;
            color: $color-black;
            border-radius: 4px;
            line-height: initial;
        }
    }

    .btn-deselect-all {
        margin: 0 !important;
        color: $color-white;
        background-color: $color-white !important;
        padding-left: 5px !important;
        &::before {
            content: '';
            @include background($image: img('select_all_black.svg'), $size: 15px, $position: left center);
            width: 15px;
            height: 15px;
            position: absolute;
        }
        span {
            padding-left: 25px;
        }

        &.disabled {
            background-color: $color-neutral-300;
            color: $color-neutral-300;
            cursor: not-allowed;
        }

        &.selector-popup {
            width: 100%;
            padding: 8px 9px;
            margin: 8px 0;
            color: $color-white;
            background-color: $main;
        }
    }
}
.content-title {
    width: auto;
    height: 20px !important;
    margin-left: 0;
    .btn {
        @include background($color: $color-neutral-200, $size: 15px, $position: 11px center);
        @include box-shadow($h: 0px, $v: 0px, $b: 4px, $s: 0px, $c: rgba($color-neutral-600, 0.05));
        padding: 8px 9px 8px 35px;
        margin: 0 0 0 0;
        font-size: 14px;
        height: 20px !important;
        width: fit-content;
        font-weight: 700;
        color: $color-white;
        border-radius: 4px;
        line-height: initial;

        span {
            font-weight: 700;
            color: $color-black;
            border-radius: 4px;
            line-height: initial;
        }
    }

    .btn-select-all {
        margin: 0 !important;
        color: $color-white;
        background-color: $color-white !important;
        padding-left: 10px !important;
        &::before {
            content: '';
            @include background($image: img('select_all_black.svg'), $size: 15px, $position: left center);
            width: 15px;
            height: 15px;
            position: absolute;
        }
        span {
            padding-left: 25px;
        }

        &.disabled {
            background-color: $color-neutral-300;
            color: $color-neutral-300;
            cursor: not-allowed;
        }

        &.selector-popup {
            width: 100%;
            padding: 8px 9px;
            margin: 8px 0;
            color: $color-white;
            background-color: $main;
        }
    }
    .btn-delete-all {
        margin: 2px auto !important;
        color: $color-white;
        background-color: $color-error-500 !important;
        padding-left: 10px !important;
        &::before {
            content: '';
            @include background($image: img('delete_ffffff.svg'), $size: 15px, $position: left center);
            width: 15px;
            height: 15px;
            position: absolute;
        }
        span {
            padding-left: 25px;
            color: $color-white;
        }

        &.disabled {
            background-color: $color-neutral-300;
            color: $color-neutral-300;
            cursor: not-allowed;
        }

        &.selector-popup {
            width: 100%;
            padding: 8px 9px;
            margin: 8px 0;
            color: $color-white;
            background-color: $main;
        }
    }
}
.content-button {
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    .btn {
        @include font-size(sm);
        @include background($color: $color-neutral-200, $size: 15px, $position: 11px center);
        @include box-shadow($h: 0px, $v: 0px, $b: 4px, $s: 0px, $c: rgba($color-neutral-600, 0.05));
        padding: 8px 9px 8px 35px;
        margin: 0 0 0 12px;
        height: auto;
        width: fit-content;
        font-family: $text-bold;
        color: $color-white;
        border-radius: 4px;
        line-height: initial;

        span {
            font-family: $text-bold;
            color: $color-white;
            border-radius: 4px;
            line-height: initial;
        }
    }
    // Common styles

    .btn-cancel {
        color: $color-neutral-600;
        background-color: $color-neutral-300h;
        border: 1px solid $color-neutral-300h;
        margin: 16px auto !important;
        padding: 0px !important;

        &:hover {
            background-color: $color-neutral-300h;
            border: 1px solid $color-neutral-300h;
        }

        &.disabled {
            background-color: $color-neutral-300h;
            color: $color-neutral-300h;
            cursor: not-allowed;
        }

        &.selector-popup {
            width: 100%;
            padding: 8px 9px;
            margin: 16px 0 0;
            color: $color-neutral-600 !important;
            background-color: $color-neutral-300h;
            border: 1px solid $color-neutral-300h;
        }

        &.multi-selector-popup {
            width: 100%;
            height: 38px;
            margin: 8px 0px !important;
            span {
                color: $main !important;
                font-size: 16px;
            }
        }

        span {
            color: $color-neutral-600 !important;
            font-weight: none;
        }
    }

    .btn-print {
        margin: 8px auto !important;
        color: $color-black;
        background-color: $color-neutral-300 !important;
        padding-left: 30px !important;
        height: 48px !important;
        &::before {
            content: '';
            @include background($image: img('printer_producttimer.svg'), $size: 20px, $position: left center);
            width: 20px;
            height: 20px;
            position: absolute;
        }
        span {
            padding-left: 30px;
            color: $color-black;
        }
        &:hover {
            background-color: $color-neutral-300;
            border: 1px solid $color-neutral-300;
        }

        &.disabled {
            background-color: $color-neutral-300;
            color: $color-neutral-300;
            cursor: not-allowed;
        }

        &.selector-popup {
            width: 100%;
            padding: 8px 9px;
            margin: 8px 0;
            color: $color-black;
            background-color: $main;
        }
    }

    .btn-add-units {
        margin: 8px auto !important;
        color: $color-black;
        background-color: $color-neutral-300 !important;
        display: flex !important;
        align-items: center;
        justify-content: center;
        gap: 10px;
        height: 48px !important;
        padding-left: 12px !important;
        padding-right: 12px !important;
        ::v-deep .btn-add-units__icon {
            flex-shrink: 0;
        }
        span {
            padding-left: 0;
            color: $color-black;
        }
        &:hover {
            background-color: $color-neutral-300;
            border: 1px solid $color-neutral-300;
        }

        &.disabled {
            background-color: $color-neutral-300;
            color: $color-neutral-300;
            cursor: not-allowed;
        }

        &.selector-popup {
            width: 100%;
            padding: 8px 9px;
            margin: 8px 0;
            color: $color-black;
            background-color: $main;
        }

        &.blocked {
            opacity: 0.45;
            cursor: not-allowed;
            pointer-events: none;
        }
    }

    .btn-reprint {
        margin: 0 auto !important;
        color: $color-white;
        background-color: $main-text !important;
        padding-left: 30px !important;
        height: 48px !important;
        width: 100% !important;
        &::before {
            content: '';
            @include background($image: img('printer_ffffff.svg'), $size: 20px, $position: left center);
            width: 20px;
            height: 20px;
            position: absolute;
        }
        span {
            padding-left: 30px;
            color: $color-white;
        }
        &:hover {
            background-color: $color-neutral-300;
            border: 1px solid $color-neutral-300;
        }

        &.disabled {
            background-color: $color-neutral-300;
            color: $color-neutral-300;
            cursor: not-allowed;
        }

        &.selector-popup {
            width: 100%;
            padding: 8px 9px;
            margin: 8px 0;
            color: $color-black;
            background-color: $main;
        }
    }

    .btn-move {
        margin: 8px auto !important;
        color: $color-white;
        background-color: $main-text !important;
        height: 48px !important;
        &::before {
            content: '';
            @include background($image: img('swap_producttimer.svg'), $size: 20px, $position: left center);
            width: 20px;
            height: 20px;
            position: absolute;
        }
        span {
            padding-left: 30px;
        }
        &:hover {
            background-color: $color-neutral-300;
            border: 1px solid $color-neutral-500;
        }

        &.disabled {
            background-color: $color-neutral-300;
            color: $color-neutral-300;
            cursor: not-allowed;
        }

        &.selector-popup {
            width: 100%;
            padding: 8px 9px;
            margin: 8px 0;
            color: $color-white;
            background-color: $main;
        }
        &.blocked {
            background-color: $main-text !important;
            opacity: 0.45;
            cursor: not-allowed;
            pointer-events: none;
        }
    }

    .btn-delete {
        margin: 16px auto !important;
        color: $color-white;
        background-color: $color-error-500 !important;
        &::before {
            content: '';
            @include background($image: img('delete_ffffff.svg'), $size: 20px, $position: left center);
            width: 20px;
            height: 20px;
            position: absolute;
        }
        span {
            padding-left: 30px;
        }
        &:hover {
            background-color: $color-neutral-300;
            border: 1px solid $color-neutral-500;
        }

        &.disabled {
            background-color: $color-neutral-300;
            color: $color-neutral-300;
            cursor: not-allowed;
        }

        &.selector-popup {
            width: 100%;
            padding: 8px 9px;
            margin: 8px 0;
            color: $color-white;
            background-color: $main;
        }
    }

    .btn-delete-timer {
        margin: 8px auto !important;
        color: $color-white;
        background-color: $color-error-500 !important;
        height: 48px !important;
        &::before {
            content: '';
            @include background($image: img('delete_ffffff.svg'), $size: 20px, $position: left center);
            width: 20px;
            height: 20px;
            position: absolute;
            margin-top: -0.25rem;
            @media screen and (max-width: 900px) {
                margin-top: 0rem;
            }
        }
        span {
            padding-left: 30px;
        }
        &:hover {
            background-color: $color-neutral-300;
            border: 1px solid $color-neutral-500;
        }

        &.disabled {
            background-color: $color-neutral-300;
            color: $color-neutral-300;
            cursor: not-allowed;
        }

        &.selector-popup {
            width: 100%;
            padding: 8px 9px;
            margin: 8px 0;
            color: $color-white;
            background-color: $main;
        }
    }

    .btn-change-view {
        margin: 8px 0px -10px 0px !important;
        color: $color-white;
        background-color: $color-secondary-500 !important;
        span {
            padding-left: 0px;
        }
        &:hover {
            background-color: $color-neutral-300;
            border: 1px solid $color-neutral-500;
        }

        &.disabled {
            background-color: $color-neutral-300;
            color: $color-neutral-300;
            cursor: not-allowed;
        }

        &.selector-popup {
            width: 100%;
            padding: 8px 9px;
            margin: 8px 0;
            color: $color-white;
            background-color: $main;
        }
        &.blocked {
            background-color: $color-neutral-500 !important;
        }
    }

    .btn-confirm {
        width: 100%;
        height: 38px;
        color: $color-white;
        background-color: $main;
        font-weight: 700;
        font-size: 16px;
        border-radius: 4px;
        border: none;
        transition: background 0.2s;
        box-shadow: none;
        letter-spacing: 0.5px;

        span {
            color: $color-white;
            font-weight: 700;
        }
        &:hover {
            background-color: darken($main, 8%);
        }
        &.disabled {
            background-color: $color-neutral-300;
            color: $color-neutral-300;
            cursor: not-allowed;
        }
        &.multi-selector-popup {
            display: flex;
            height: 38px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            margin: 0px;
            padding: 0px;
            align-self: stretch;
            span {
                font-size: 16px;
            }
        }
    }
}
.content-button.expanded {
    width: 100%;
    padding: 0 !important;
}
.content-button.expanded {
    width: 100%;
    padding: 0 !important;
}
</style>
